__turbopack_context__.v({
  "active": "toggle-module-scss-module__LYflXG__active",
  "animate": "toggle-module-scss-module__LYflXG__animate",
  "container": "toggle-module-scss-module__LYflXG__container",
  "label": "toggle-module-scss-module__LYflXG__label",
  "option": "toggle-module-scss-module__LYflXG__option",
  "pill": "toggle-module-scss-module__LYflXG__pill",
  "radioInput": "toggle-module-scss-module__LYflXG__radioInput",
  "ready": "toggle-module-scss-module__LYflXG__ready",
  "small": "toggle-module-scss-module__LYflXG__small",
  "toggle": "toggle-module-scss-module__LYflXG__toggle",
  "toggleSmall": "toggle-module-scss-module__LYflXG__toggleSmall",
});
